import { useEffect, useState } from "react"
import { getChartsData } from "../api"

export const useCompareCharts = (codes = []) => {
  const safeCodes = Array.isArray(codes) ? codes : []

  const [data, setData] = useState({})

  useEffect(() => {
    if (!safeCodes.length) return

    Promise.all(safeCodes.map(code => getChartsData(code)))
      .then(res => {
        const mapped = {}

        safeCodes.forEach((code, i) => {
          mapped[code] = res[i].data
        })

        setData(mapped)
      })
  }, [JSON.stringify(safeCodes)])

  return data
}
